<template>
	<div class="VideoListBox">
		<div class="common-header-wrap">
            <mt-header title="Video List" class="common-header">
                <mt-button slot="left" icon="back"  @click="backoff()"></mt-button>
                <mt-button slot="right" @click="addvideo">Upload Video</mt-button>
            </mt-header>
        </div>
        <div class="VideoContentBoxs">
        	<div class="VideoListConBox" v-for="(item,index) in video_list">
        		<div class="VideoListConHeaderBox" @click="detailsvideo(item.svideo_id)">
        			<p>{{item.svideo_name}}</p>
        			<span class="Toppings" v-if="item.svideo_top==1">Top</span>
        		</div>
        		<div class="videodetails">
        			<div class="videocronimg" @click="detailsvideo(item.svideo_id)">
        				<img :src="item.svideo_pic" />
        			</div>
        			<div class="videoctextbox">
        				<div class="videooperation"  @click="detailsvideo(item.svideo_id)">
        					<span>
        						<i class="item-icon iconfont">&#xe658</i>
        					</span>
        					<p>Edit</p>
        				</div>
        				<div class="videooperation" @click="deletevideo(item.svideo_id)">
        					<span>
        						<i class="item-icon iconfont">&#xe669</i>
        					</span>
        					<p>Delete</p>
        				</div>
        			</div>
        		</div>
        		<div class="videobottom">
        			<p>Likes:<span>{{item.svideo_like_count}}</span></p>
        			<p>Views:<span>{{item.svideo_view_count}}</span></p>
        			<p>Order:<span>{{item.svideo_sort}}</span></p>
        		</div>
        	</div>
        </div>
	</div>
</template>

<script>
	import { getmyvideo,getdeletevideo,getisVideoMan} from '../../../api/video'
	import { mapState } from 'vuex'
	import { Toast,MessageBox } from 'mint-ui'
export default {
  name: 'video_list',
  data () {
    return {
      member_id:"",
      page:0,
      video_list:"",
    }
  },
  
  components: {
    
  },
  mounted () {
	
  },
  created: function () {

  	if(this.user){
  		getisVideoMan(this.user.member_id,this.token).then((res) => {
			if(res.result.isman>0){
				this.page=this.page+1;
  				this.videolist()
				
			}else{
				this.$router.push({ name: 'MemberVideoIndex',query: { gologin: "1" }})
			}
	   })
  	}
   
  },
  computed: {
    ...mapState({
    	isOnline: state => state.member.isOnline,
    	user: state => state.member.info,
    	token: state => state.member.token
    })
  },
  methods: {
  	//获取视频列表
  	videolist:function(){
  		getmyvideo(this.page,this.user.member_id,this.token).then(res => {
	      	if(res.code==10000){
	      		if(this.video_list==""){
	      			this.video_list=res.result.video_list;
	      		}else{
	      			this.video_list=this.video_list.concat(res.result.video_list);
	      		}		
	      		
	      	}
	      	
	    })
  	},
  	//删除视频
  	deletevideo:function(videoids){
  		MessageBox.confirm('Are you sure you want to delete this video?',{confirmButtonText: 'Submit',
      		  cancelButtonText: 'Cancel',}).then(action => {
    		getdeletevideo(videoids,this.user.member_id,this.token).then(res=>{
				if(res.code==10000){
		      		this.page=1;
		      		this.video_list=""
					this.videolist();
		      	}
				Toast(res.message)
			})	
        })
  	},
  	addvideo:function(){
  		this.$router.push({ name: 'MemberAddVideo'})
  	},
  	detailsvideo:function(videoids){
  		this.$router.push({ name: 'MemberAddVideo', query: { videoid: videoids}})
  	},
  	//返回上一页
   backoff:function(){
   	var gologin=this.$route.query.gologin;
   	if(gologin && gologin!=undefined){
   		this.$router.push({ name: 'MemberIndex' })
   	}else{
   		this.$router.go(-1);
   	}
   },
  	
  }
}		
</script>


<style lang="scss" scoped>
.videoctextbox{text-align: right;}
.videooperation{display: inline-block;text-align: center;margin-left: 0.6rem;}
.videooperation span{display: inline-block;width: 2rem;height: 2rem;border-radius: 2rem;background-color: #F1F1F1;line-height: 2rem;}
.videooperation span i.iconfont{color: #000;font-weight: bold;}
.videoctextbox .videooperation p{font-size: 0.6rem;line-height: 1rem;color: #000;}
.VideoContentBoxs{padding-bottom: 3rem;}
.VideoListConBox{background: #fff;margin-bottom: 0.5rem;border-bottom: 1px solid #ddd;}
.VideoListConHeaderBox{padding: 0.3rem;border-bottom: 1px dashed #ddd;position: relative;padding-right: 2rem;box-sizing: border-box;}
.VideoListConHeaderBox p{font-size: 0.7rem;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;color: #000;line-height: 1rem;}
.VideoListConHeaderBox span.Toppings{ display: inline-block; color: #fff; padding: 0 6px; border-radius: 3px; background: #d9001b; margin-right: 0px; line-height: 20px; position: absolute; top: 0.4rem; right: 3px; z-index: 10; font-size: 12px; }
.videodetails{padding: 0.3rem 0.5rem;box-sizing: content-box;padding-right: 0.1rem;}
.videocronimg{display: inline-block;width: 5rem;height: 5rem;border: 1px solid #ddd;line-height: 4.8rem;box-sizing: border-box;text-align: center;overflow: hidden;vertical-align: middle;}
.videocronimg img{max-width: 100%;max-height: 100%;}
.videoctextbox{display: inline-block;vertical-align: middle;width: calc(100% - 5.3rem);box-sizing: border-box;padding-left: 0.3rem;}
.videoctextbox p{font-size: 0.7rem;color: #888;line-height: 1rem;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 5;-webkit-box-orient: vertical;}
.videobottom{padding: 0rem 2rem 0.2rem 0.2rem;position: relative;padding-right: 2rem;max-height: 3rem;overflow: hidden;}
.videobottom p{display: inline-block;font-size: 0.6rem;margin-right: 0.8rem;color: #666;}
.videobottom p span{display: inline-block;color: #333;margin-left: 2px;}
.videobottom span.deletevideos{ display: inline-block; color: #fff; padding: 0 0.4rem; border-radius: 3px; background: #FF0000; margin-right: 0px; line-height: 1rem; position: absolute; top: 0.2rem; right: 3px; z-index: 11; font-size: 0.6rem; }
</style>